/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Création d'un indice et rattachement initial à des branches.
 * @export
 * @interface CreateIndiceCommand
 */
export interface CreateIndiceCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateIndiceCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIndiceCommand
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateIndiceCommand
     */
    branchIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateIndiceCommand interface.
 */
export function instanceOfCreateIndiceCommand(value: object): value is CreateIndiceCommand {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CreateIndiceCommandFromJSON(json: any): CreateIndiceCommand {
    return CreateIndiceCommandFromJSONTyped(json, false);
}

export function CreateIndiceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIndiceCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
        'branchIds': json['branchIds'] == null ? undefined : json['branchIds'],
    };
}

export function CreateIndiceCommandToJSON(json: any): CreateIndiceCommand {
    return CreateIndiceCommandToJSONTyped(json, false);
}

export function CreateIndiceCommandToJSONTyped(value?: CreateIndiceCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'label': value['label'],
        'branchIds': value['branchIds'],
    };
}

